import { render, staticRenderFns } from "./SsPopover.vue?vue&type=template&id=336d717c&"
import script from "./SsPopover.vue?vue&type=script&lang=js&"
export * from "./SsPopover.vue?vue&type=script&lang=js&"
import style0 from "./SsPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports